export const UPAYA_TINDAK_LANJUT = [
  'Pendidikan yang Mengantarkan Keselamatan dan Kebahagiaan',
  'Mengenali dan Memahami Diri sebagai Pendidik',
  'Makna Kurikulum dalam Pendidikan',
  'Refleksi dalam Pembelajaran',
  'Kolaborasi untuk Inklusi',
  'Merancang Pembelajaran',
  'Memahami Murid',
  'Persiapan Pembelajaran Berdiferensiasi',
  'Layanan Peminatan dan Perencanaan Individual',
]

export const DUKUNGAN_UPAYA_TINDAK_LANJUT = [
  'Sumber daya untuk melakukan kegiatan belajar/praktik',
  'Penyediaan atau pembelian alat dukung pembelajaran',
  'Penyediaan atau akses ke sumber belajar melalui satuan pendidikan',
  'Izin untuk mengikuti pelatihan di luar satuan pendidikan',
  'Memperoleh mentoring dari KS, Guru atau Pemateri Eksternal, atau Manajemen',
]
